import { registerComponent } from '@gig/magic-common';
import FormFieldComponent from './form-field.vue.js';
export { default as FormFieldComponent } from './form-field.vue.js';

var FormField = registerComponent(FormFieldComponent, true);

export { FormField };
